export default __webpack_public_path__ + "static/media/hold-n-drag.737aed8e.svg";